import { Button, Card } from '@ohear/ui'
import { useState } from 'react'
import type { RtLink } from '../lib/api'
import { RoleBadge } from './RoleBadge'

export function LinkCard({ link, label }: { link: RtLink; label?: string }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link.url)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // clipboard unavailable (http origin etc.) — select-able URL is still visible
    }
  }

  return (
    <Card dense data-testid="rt-link-card">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <RoleBadge role={link.role} label={label} />
          <div className="mt-1.5 select-all break-all font-mono text-[12px] text-[var(--text-2)]">
            {link.url}
          </div>
        </div>
        <Button size="sm" variant="secondary" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
    </Card>
  )
}
